"use client";

import { useEffect, useState } from "react";

export default function EstimatedRead({ id }: { id: string }) {
  const [time, set_time] = useState<number | null>(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    // JavaScript code
    const contentElement = document.getElementsByClassName(id)?.[0];

    const words = contentElement?.textContent?.split(" ").length ?? 1;
    const averageReadingSpeed = 200; // Adjust this as needed

    const estimatedReadingTime = Math.ceil(words / averageReadingSpeed);

    set_time(estimatedReadingTime);
  }, [id]);

  // Prevent hydration mismatch by using suppressHydrationWarning
  // and showing a placeholder until mounted
  if (!mounted) {
    return <span suppressHydrationWarning>Estimated Read: -- min</span>;
  }

  return <span suppressHydrationWarning>Estimated Read: {time ?? 0} min</span>;
}
